import axios from 'axios';
import { Message } from 'element-ui';

// 获取普通 API 地址：开发环境走 /api 代理，生产环境使用当前域名 + :3000
function getBaseApi () {
  console.log('process.env.NODE_ENV', process.env.NODE_ENV);

  if (process.env.NODE_ENV === 'production') {
    // 运行时获取 hostname，避免打包时报错
    if (typeof window !== 'undefined' && window.location) {
      return window.location.protocol + '//' + window.location.hostname + ':3000';
    }
    return 'http://localhost:3000';
  }
  return window.location.protocol + '//' + window.location.hostname + ':3000';
}

// 用户中心 API 地址：开发环境走 /user-api 代理，生产环境直接请求
const userApi = process.env.NODE_ENV === 'production' ? 'https://api-work.beesfpd.com/api' : '/user-api';

// 创建请求/响应拦截器的工厂函数
function createInterceptors (instance) {
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('beesfpd_token');
      if (token && config.headers) {
        config.headers.Authorization = 'Bearer ' + token;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => {
      const res = response.data;
      if (res && (res.code === 200 || res.success)) {
        return res;
      }

      const msg = (res && (res.msg || res.message)) || '请求失败';
      Message.error(msg);
      return Promise.reject(res);
    },
    (error) => {
      const msg =
        (error && error.response && error.response.data && error.response.data.msg) ||
        (error && error.message) ||
        '请求失败，请稍后重试';
      Message.error(msg);
      return Promise.reject(error);
    }
  );
}

// 普通 API 实例（本地 node 服务）
const service = axios.create({
  baseURL: getBaseApi(),
  timeout: 50000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
});
createInterceptors(service);

// 用户中心 API 实例（登录/注册/找回密码等）
const userService = axios.create({
  baseURL: userApi,
  timeout: 50000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
});
createInterceptors(userService);

// 普通 API 请求封装
export const request = {
  get (config) {
    return service({ ...config, method: 'get' });
  },
  post (config) {
    return service({ ...config, method: 'post' });
  },
  put (config) {
    return service({ ...config, method: 'put' });
  },
  delete (config) {
    return service({ ...config, method: 'delete' });
  }
};

// 用户中心 API 请求封装（登录/注册/找回密码等）
export const userRequest = {
  get (config) {
    return userService({ ...config, method: 'get' });
  },
  post (config) {
    return userService({ ...config, method: 'post' });
  },
  put (config) {
    return userService({ ...config, method: 'put' });
  },
  delete (config) {
    return userService({ ...config, method: 'delete' });
  }
};

export default request;



// WEBPACK FOOTER //
// ./src/utils/request.js